import React from "react";

const CustomTextArea = ({
  name,
  onChange,
  value,
  label,
  rows,
  labelStyles,
  inputStyles,
}) => {
  return (
    <div className="form-group">
      <label style={{ ...labelStyles }} htmlFor={name}>
        {label}
      </label>
      <textarea
        className="form-control"
        id={name}
        name={name}
        rows={rows}
        value={value}
        onChange={onChange}
        style={{ ...inputStyles }}
      />
    </div>
  );
};

export default CustomTextArea;
